export const demoLink = (industry?: string) => {
  //FIXME: add relevant industries and feeds as soon as they are available
  switch (industry) {
    case "fashion": {
      return "";
    }
    case "electronics": {
      return "";
    }
    default:
      return "https://storage.googleapis.com/api-project-761142975859.appspot.com/schuhcenter-feed-test-small.csv";
  }
};
